/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum StepType {
  StartTask = 0,
  ArrivedToPickup = 10,
  TradePlateRecording = 11,
  ConfirmInsurance = 9,
  PickupPhoto = 1,
  PickupSignature = 2,
  DropOffPhoto = 3,
  DropOffSignature = 4,
  StartMovement = 5,
  EndMovement = 6,
  Rating = 7,
  CompleteTask = 8,
  CallByacarConfirmation = 12,
  Paused = 13,
  TradePlateNotification = 14,
}
